const onError = (error: any) => {
	console.error(error);
};

export default onError;
